import { render, staticRenderFns } from "./LoadingContainer.vue?vue&type=template&id=457f6d90&scoped=true&"
import script from "./LoadingContainer.vue?vue&type=script&lang=js&"
export * from "./LoadingContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f6d90",
  null
  
)

export default component.exports